import React, {useState, useEffect} from 'react'
import axiosInstance from '../../http/axios';

import Toast from '../../toast';
import Header from '../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import { IconButton } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';
import NavLink from '../nav_link/NavLink';
import SearchOutlined from '@mui/icons-material/SearchOutlined';

const Barber = () => {

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const [data, setData] = useState([]);
     const [maxLength, setMaxDataLength] = useState(0);
     const [errorMessage, setErrorMessage] = useState(null);
     const [status, setStatus] = useState("active");
     const [searchQuery, setSearchQuery] = useState(null);
     const tableHead = ["Barber ID", "Mobile Number", "Balance", "Total Earning", "Area", "Services", ""];
     const selectionItems = ["Enabled", "Desabled"];
     const selectionItemKeys = ["active", "suspended"];

     const onPageChange = async (e, pageIndex, mStatus) => {
          try {
               const params = new URLSearchParams();
               params.append("skip", 20 * (pageIndex-1));
               params.append("limit", 20);
               params.append("filterByNew", true);

               if(searchQuery){
                    params.append("searchQuery", searchQuery);
               }
               if(mStatus){
                    params.append("status", mStatus);
               }
               else params.append("status", status);
               const res = await axiosInstance.get('admin/barber', {
                    params: params
               });
               setErrorMessage(null);
               setData(res.data.data);
               setMaxDataLength(res.data.maxLength);
          } 
          catch (error) {
               setErrorMessage("Failed");
          }
     }

     useEffect(async ()=>{
          onPageChange(null, 1);
     }, []);

     return (
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         {/* <IconButton onClick={()=>naviagte(-1)}><ArrowBackRounded/></IconButton> */}
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Barbers</h5>
                    </div>
                    <div className='d-flex align-items-center'>
                         <div className='d-flex align-items-center' style={{border: '1px solid #A29694', marginRight: "20px", padding: '7px 20px', borderRadius: "5px"}}>
                                   <input type="text" style={{background: "#F2EDF3", border: 'none', marginRight: "20px", }} placeholder='Search barber...' onChange={(e)=>setSearchQuery(e.target.value.trim())}/>
                                   <SearchOutlined htmlColor='#A29694' onClick={()=>{
                                        onPageChange(null, 1, status);
                                   }} />
                              </div>
                         <DropdownMenu items={selectionItems} onChange={(value, i)=> {
                                   const status = selectionItemKeys[i];
                                   setStatus(status);
                                   onPageChange(null, 1, status);
                              }}/>
                    </div>
                    
               </div>
               <div className="__table_root">
                    <table cellspacing="0" cellpadding="0" className="table">
                    <tr>
                         { tableHead.map((value, i)=> <th>{value}</th>) }
                    </tr>
                    { errorMessage ? null : ( data.length != 0 ? data.map((value, i)=> <Item data={value} position={i}/>) : null) }
                    </table>
                    { data.length != 0 ? null : <ErrorMessage message='Empty'/> }
                    { errorMessage ? <ErrorMessage message={errorMessage}/> : null }
                    <div className='d-flex justify-content-between'>
                    <div></div>
                         <Pagination onChange={onPageChange} count={maxLength != 0 ? ~~((maxLength/20)+1) : 0} shape="rounded" />
                    </div>
               </div>
          </>
     );
}

const Item = (props) => {
     const { loginId, _id, accountStatus, services, mobileNumber, balance, totalEarning, area, date } = props.data;
     const [status, setStatus] = useState(accountStatus);
     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const onAction = async (status) => {
          try {
               setStatus(status);
               const rBody = new FormData();
               rBody.append("id", _id)
               rBody.append("status", status)
               const res = await axiosInstance.patch("admin/barber-account-status", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
          }
     }

     return(
          <tr>
               <td>{loginId}</td>
               <td>{mobileNumber}</td>
               <td>₹{balance}</td>
               <td>₹{totalEarning}</td>
               <td>{area.map(val => <span className="p-2 m-1 rounded border text-center" style={{background: '#f2f2f2', }}>{val}</span>)}</td>
               <td>{services.map(val => <span className="p-2 m-1 rounded border text-center" style={{background: '#f2f2f2', }}>{val.toUpperCase()}</span>)}</td>
               {status == 'active' ? <td>
                    <button className='item_action_btn' style={{background: '#df1111'}} onClick={()=>onAction('suspended')}>Suspend Now</button>
               </td> : <button className='item_action_btn' style={{background: 'green'}} onClick={()=>onAction('active')}>Active Now</button>}
          </tr>
     );
};

const ErrorMessage = (props) => {
     return (
          <div className='d-flex align-items-center justify-content-center' style={{height: "300px", fontSize: '16px'}}>
               {props.message}
          </div>
     );
}

export default Barber;